export enum TemplateType {
    STORAGE_OBJECT_FOLDER = 'STORAGE_OBJECT_FOLDER',
    STORAGE_OBJECT_FILE = 'STORAGE_OBJECT_FILE',
    AUDIT_STORAGE_OBJECT_FOLDER = 'AUDIT_STORAGE_OBJECT_FOLDER',
    AUDIT_STORAGE_OBJECT_FILE = 'AUDIT_STORAGE_OBJECT_FILE',
    UI_CONFIGURATION_SETTINGS = 'UI_CONFIGURATION_SETTINGS',
    UI_COMPONENT_SETTINGS = 'UI_COMPONENT_SETTINGS'
}